import {dispatchAppEvent} from '../dispatch';
import {Constructor} from '../common/types';

/**
 * This class use only for dispatch events to EventBus
 */
export class EventBusDispatcher {
	private constructor() {
	}

	public static dispatch<T>(event: (...args) => T, args: T): void;
	public static dispatch<T>(event: Constructor<T>, args?: T): void;
	public static dispatch<T>(event: T, args?: any): void;
	public static dispatch(event: any, args?: any): void {
		dispatchAppEvent(event, args);
	}
}
